export default function validateAsesorForm(fieldName, fieldValue, fields) {
    let validationErrors = {};
    let numberOfErrors = 0;
    if (fieldName !== null || fieldValue !== null) {
        switch (fieldName) {
            case "sect_nombre":
                if (!fieldValue) {
                    validationErrors.sect_nombre = "El nombre del secetor es obligatorio";
                    numberOfErrors += 1;
                }
                break;
            
            case "sect_estado":
                if (!fieldValue) {
                    validationErrors.sect_estado = "Escoger el estado del sector es obligatorio";
                    numberOfErrors += 1;
                }
                break;


            default:
                break;
        }
    } else {
        if (!fields.sect_nombre) {
            validationErrors.sect_nombre =  "El nombre del sector es obligatorio";
            numberOfErrors += 1;
        }
        if (!fields.sect_estado) {
            validationErrors.sect_rol = "Escoger el estado del sector es obligatorio";
            numberOfErrors += 1;
        }

 

    }

    return { validationErrors, numberOfErrors }
}